import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import {
  BROWSER_PROFILES,
  DEFAULT_BROWSER_PROFILE,
  FARM_TYPES,
  farmTypeLabel,
} from '@/lib/farm';

/**
 * Farm Type = Browser | Mobile.
 * Browser profile (TLS fingerprint) only appears when Farm Type is Browser.
 */
export function FarmTypeFields({
  runtime,
  tlsProfile,
  onRuntimeChange,
  onTlsProfileChange,
  disabled = false,
  showProfile = true,
  compactHint = false,
  runtimeTestId = 'farm-type-select',
  profileTestId = 'browser-profile-select',
}) {
  const isBrowser = (runtime || 'browser') !== 'mobile';
  const profile = tlsProfile || DEFAULT_BROWSER_PROFILE;

  return (
    <div className="space-y-3" data-testid="farm-type-fields">
      <div className={`grid gap-3 ${showProfile && isBrowser ? 'grid-cols-2' : 'grid-cols-1'}`}>
        <div className="space-y-1.5">
          <Label>Farm Type</Label>
          <Select
            disabled={disabled}
            value={runtime || 'browser'}
            onValueChange={(v) => onRuntimeChange?.(v)}
          >
            <SelectTrigger data-testid={runtimeTestId}><SelectValue /></SelectTrigger>
            <SelectContent>
              {FARM_TYPES.map((t) => (
                <SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        {showProfile && isBrowser && (
          <div className="space-y-1.5">
            <Label>Browser profile</Label>
            <Select
              disabled={disabled}
              value={profile}
              onValueChange={(v) => onTlsProfileChange?.(v)}
            >
              <SelectTrigger data-testid={profileTestId}><SelectValue /></SelectTrigger>
              <SelectContent>
                {BROWSER_PROFILES.map((p) => (
                  <SelectItem key={p.value} value={p.value}>{p.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        )}
      </div>
      <p className="text-[10px] text-[hsl(var(--text-3))]">
        {isBrowser
          ? (compactHint
            ? 'Browser farm uses Camoufox + the selected TLS profile for server-side HTTP.'
            : 'Browser farm runs stealth desktop sessions. Profile sets the sticky TLS/HTTP identity (same catalog as agent detail).')
          : 'Mobile farm runs on VMOS cloud phones. Bind a pad after create; browser profiles do not apply.'}
      </p>
      {!showProfile && (
        <p className="text-[10px] text-[hsl(var(--text-3))]">
          Default: {farmTypeLabel(runtime)}. Browser profile is chosen when creating an agent.
        </p>
      )}
    </div>
  );
}
